import { render, staticRenderFns } from "./tugas_pokok.vue?vue&type=template&id=5680bf50&"
import script from "./tugas_pokok.vue?vue&type=script&lang=js&"
export * from "./tugas_pokok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports